import React, { useEffect, useState } from 'react';
import '../../../EpicGame/Components/Login/login.css';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { MdDeleteOutline } from "react-icons/md";
import ApiService from '../../../EpicGame/services/apiService';
import moment from 'moment';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { ClipLoader } from 'react-spinners';

const RegisterUser = () => {
    let navigate = useNavigate();

    const [formData, setFormData] = useState({
        email: '',
        firstName: '',
        lastName: '',
        username: '',
        phoneNumber: '',
        password: '',
    });

    const [showPassword, setShowPassword] = useState(false);
    const [show, setShow] = useState(false);
    const [loader, setLoader] = useState(false);
    const [item, setItem] = useState();
    const handleClose = () => setShow(false);
    const handleShow = (items) => {
        setItem(items)
        setShow(true);
    }
    const apiService = new ApiService()

    const [rowData, setRowData] = useState([]);

    useEffect(() => {
        fetchuser();
    }, []);

    const fetchuser = async () => {
        try {
            const params = new URLSearchParams();
            params.append('role', "Admin");
            const response = await apiService.getApiParamater('USER_LIST', `?${params.toString()}`);
            setRowData(response?.data);
        } catch (error) {
            console.error("Error fetching user data:", error);
        }
    };
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    const handlelogin = async () => {
        setLoader(true)
        if (!formData?.email) {
            setLoader(false)
            toast.warning("Enter Email")
            return;
        } else if (!formData?.username) {
            setLoader(false)
            toast?.warning("Enter Password ")
            return;
        } else if (!formData?.password) {
            setLoader(false)
            toast?.warning("Enter Password ")
            return;
        }
        const apiService = new ApiService();
        const currentDatetimeUTC = new Date().toISOString();
        let body = {
            username: formData?.username,
            email: formData?.email,
            mobileNumber: formData?.phoneNumber,
            userPassword: formData?.password,
            registrationTime: currentDatetimeUTC,
            firstName: formData?.firstName,
            lastName: formData?.lastName
        }
        try {
            const response = await apiService.post('CREATE_ADMIN_USER', body);
            if (response?.status === 200) {
                fetchuser()
                setFormData({
                    email: '',
                    firstName: '',
                    lastName: '',
                    username: '',
                    phoneNumber: '',
                    password: '',
                });
                setLoader(false)
            }
            setLoader(false)
        } catch (error) {
            setLoader(false)
            console.error("Error Creating User:", error);
        }
    };
    const DeleteItem = async () => {
        // const apiService = new ApiService();
        // let body = {
        //     id: parseInt(item?.id)
        // }
        // let res = await apiService.delete("DELETE_ITEM", { data: body });

        // if (res?.data?.statusCode === 204 || res?.data?.statusCode === 200) {
        //     // Show success toast
        //     setShow(false)
        //     toast.success(res.data.message)
        //     GetMenu()
        // }
        // else {
        //     toast.warning(res.data.message);
        // }
    }
    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };
    return (
        <div className='p-lg-5 m-5'>
            <div className='blackBox p-3 p-lg-5 mx-lg-5 width-100'>
                <form className=''>
                    <div className='row mb-3'>
                        <div class="col">
                            <label for="firstName" class="form-label" style={{ color: "#fff" }}>First Name</label>
                            <input type="text" class="form-control" id="firstName" aria-describedby="firstName"
                                name="firstName"
                                value={formData.firstName}
                                onChange={handleChange} />
                        </div>
                        <div class="col">
                            <label for="lastName" class="form-label" style={{ color: "#fff" }}>Last Name</label>
                            <input type="text" class="form-control" id="lastName" aria-describedby="lastName"
                                name="lastName"
                                value={formData.lastName}
                                onChange={handleChange} />
                        </div>
                        <div class="col">
                            <label for="username" class="form-label" style={{ color: "#fff" }}>UserName</label>
                            <input type="text" class="form-control" id="username" aria-describedby="username"
                                name="username"
                                value={formData.username}
                                onChange={handleChange} />
                        </div>
                    </div>
                    <div className='row mb-3'>
                        <div class="col">
                            <label for="email" class="form-label" style={{ color: "#fff" }}>Email</label>
                            <input type="email" class="form-control" id="email" aria-describedby="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange} />
                        </div>
                        <div class="col">
                            <label for="phoneNumber" class="form-label" style={{ color: "#fff" }}>Mobile Number</label>
                            <input type="number" class="form-control" id="phoneNumber" aria-describedby="phoneNumber"
                                name="phoneNumber"
                                value={formData.phoneNumber}
                                onChange={handleChange} />
                        </div>
                        <div class="col">
                            <label for="password" class="form-label" style={{ color: "#fff" }}>Login Password</label>
                            <div className="input-group">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    className="form-control"
                                    id="password"
                                    name="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                />
                                <span className="input-group-text" onClick={togglePasswordVisibility} style={{ cursor: 'pointer' }}>
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </span>
                            </div>
                        </div>
                    </div>
                </form>
                <div className='row justify-content-center'>
                    <div className='col-3'>
                        {loader === true ?
                            <button type="submit" class="btn btn-primary" ><ClipLoader color="#00000" size={25} /></button> :
                            <button type="submit" class="btn btn-primary" onClick={handlelogin}>Register Now</button>
                        }
                    </div>
                </div>
            </div>
            <div className='blackBox mt-3 p-3 mx-lg-5 width-100' style={{ overflow: 'auto' }}>
                <table class="table table-bordered table-dark" style={{ width: '100%', overflow: 'auto' }}>
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">First Name</th>
                            <th scope="col">Last Name</th>
                            <th scope="col">userName</th>
                            <th scope="col">Email</th>
                            <th scope="col">Mobile Number</th>
                            <th scope="col">Registration Date</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rowData?.map((row, index) => (
                            <tr>
                                <th scope="row">{index + 1}</th>
                                <td>{row?.firstName}</td>
                                <td>{row?.lastName}</td>
                                <td>{row?.username}</td>
                                <td>{row?.email}</td>
                                <td>{row?.mobileNumber}</td>
                                <td>{moment(row?.registrationTime).format("MMM Do YY")}</td>
                                <td>
                                    <div><MdDeleteOutline size={25} onClick={() => handleShow(row)} /></div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete User</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you Sure you want to delete {item?.username}</Modal.Body>
                <Modal.Footer>
                    <div className='d-flex gap-3'>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={() => DeleteItem()}>
                            Delete
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default RegisterUser;
